import { useHistory } from "react-router-dom";
import ArrowForward from "@mui/icons-material/ArrowForward";
import { Button, Stack, Tooltip, Typography } from "@mui/material";

import useSegmentTrackEvent from "../../../../utils/useSegmentTrackEvent";
import HomePageCard from "../HomePageCard";
import { useIsSupportUser, useZendeskTickets } from "../hooks";
import { LoadingCard } from "../LoadingCard";
import { TicketRow } from "../Rows/TicketRow";

export const RecentInquiriesCard = () => {
  const { tickets, loading } = useZendeskTickets();
  const isSupportUser = useIsSupportUser();
  const { trackEvent } = useSegmentTrackEvent();

  const history = useHistory();

  if (loading) {
    return <LoadingCard title="Recent expert inquiries" />;
  }

  const displayedTickets = tickets.slice(0, 2);

  const handleExpertInquiryClick = () => {
    // Track the "Expert Inquiry" event
    trackEvent("Expert Inquiry", {
      source: "Home Dashboard",
      feature: "Home Dashboard",
      target_internal_destination_description: "Expert inquiry action button",
    });

    history.push("./support?open-case-iq=true");
  };

  return (
    <HomePageCard title="Recent expert inquiries">
      <Stack sx={{ height: 177, p: 3, pt: 2 }} justifyContent="space-between">
        {displayedTickets.map((zendeskTicket, index) => (
          <TicketRow
            key={zendeskTicket.ticket.id}
            zendeskTicket={zendeskTicket}
            isLastItem={index === displayedTickets.length - 1}
          />
        ))}
        {tickets.length === 0 && (
          <Typography variant="body2" color="text.secondary" pt={1}>
            No expert inquiries yet
          </Typography>
        )}
        <Tooltip
          title={
            isSupportUser
              ? "You don't have the correct permissions to perform this action. Please contact your admin."
              : ""
          }
        >
          <span>
            <Button
              variant="outlined"
              size="small"
              disabled={isSupportUser}
              data-cy="cloud-waste-insights-btn"
              endIcon={<ArrowForward />}
              sx={{ mt: 1, width: "fit-content", "@media print": { display: "none" } }}
              onClick={handleExpertInquiryClick}
            >
              Expert inquiry
            </Button>
          </span>
        </Tooltip>
      </Stack>
    </HomePageCard>
  );
};
